import { Capacitor } from '@capacitor/core'
import { RouteAction, RouterDirection, useIonRouter } from '@ionic/react'

import { pageAnimationBuilder } from '@apps-common/lib/page-animations'
// import { useOrderDetailsStore } from '@apps-common/stores/orderDetailsStore'
// import { useUnitActivationDetailsStore } from '@apps-common/stores/unitActivationDetailsStore'
import { useNavigationHistory } from '@apps-common/stores/useNavigationHistory'
import { Route } from '@apps-common/types/routes'

export interface IAppNavigationOptions {
  routeUrl: string
  route: Route
  direction?: RouterDirection
  action?: RouteAction
  options?: any
}

export interface IAppNavigation {
  platform: string
  canGoBack: boolean
  previousRoute: Route | undefined
  navigateReplace: (opts: IAppNavigationOptions) => void
  navigateForward: (opts: IAppNavigationOptions) => void
  navigateBack: (opts?: IAppNavigationOptions) => void
  navigateRoot: (opts: IAppNavigationOptions) => void
  navigateNone: (opts: IAppNavigationOptions) => void
  navigateNewTab: (opts: IAppNavigationOptions) => void
  // navigateUnitDetails: (opts: IAppNavigationOptions, id: string, status: string) => void
  // navigateUnitActivationDetails: (opts: IAppNavigationOptions, id: number) => void
  // navigateOrderDetails: (opts: IAppNavigationOptions, id: string) => void
}

export const useNavigation = (): IAppNavigation => {
  const platform = Capacitor.getPlatform()
  const router = useIonRouter()
  const { add, previous } = useNavigationHistory()
  // const { setId: setUnitActivationId } = useUnitActivationDetailsStore()
  // const { setId: setOrderId } = useOrderDetailsStore()

  const navigateReplace = (opts: IAppNavigationOptions) => {
    // const { routeUrl, route, direction = 'forward', action = 'replace', options = {} } = opts
    const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

    add(route)
    router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  }

  const navigateForward = (opts: IAppNavigationOptions) => {
    const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

    add(route)
    router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  }

  const navigateBack = (opts?: IAppNavigationOptions) => {
    const { routeUrl, route, direction = 'back', action = 'pop', options = {} } = opts || {}

    const previousRoute = previous()

    // console.log('canGoBack', router.canGoBack())

    if (previousRoute) {
      add(previousRoute)
    }
    router.goBack()
  }

  const navigateRoot = (opts: IAppNavigationOptions) => {
    // const { routeUrl, route, direction = 'root', action = 'replace', options = {} } = opts
    const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

    add(route)
    router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  }

  const navigateNone = (opts: IAppNavigationOptions) => {
    const { routeUrl, route, direction = 'none', action, options = {} } = opts

    add(route)
    router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  }

  const navigateNewTab = (opts: IAppNavigationOptions) => {
    const { routeUrl, route, direction = 'none', action, options = {} } = opts

    // router.push(routeUrl, direction, action, options, pageAnimationBuilder)

    window.open(routeUrl, '_blank')
  }

  // const navigateUnitDetails = (opts: IAppNavigationOptions, id: string, status: string) => {
  //   const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

  //   add(route)
  //   router.push(routeUrl.replace(':status', status).replace(':unitId', id), direction, action, options, pageAnimationBuilder)
  // }

  // const navigateUnitActivationDetails = (opts: IAppNavigationOptions, id: number) => {
  //   const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

  //   add(route)
  //   // setUnitActivationId(id)
  //   router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  // }

  // const navigateOrderDetails = (opts: IAppNavigationOptions, id: string) => {
  //   const { routeUrl, route, direction = 'forward', action = 'push', options = {} } = opts

  //   add(route)
  //   // setOrderId(id)
  //   router.push(routeUrl, direction, action, options, pageAnimationBuilder)
  // }

  return {
    platform,
    canGoBack: router.canGoBack(),
    previousRoute: previous(),
    navigateReplace,
    navigateForward,
    navigateBack,
    navigateRoot,
    navigateNone,
    navigateNewTab
    // navigateUnitDetails,
    // navigateUnitActivationDetails,
    // navigateOrderDetails
  }
}
